import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

/**
 * Show Telegram's native BackButton on non-root pages.
 * On click it calls navigate(-1). Hides on cleanup.
 */
export function useTelegramBackButton() {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const backButton = window.Telegram?.WebApp?.BackButton
    if (!backButton) return

    const isRoot = location.pathname === '/' || location.pathname === '/login'

    if (isRoot) {
      backButton.hide()
      return
    }

    const handleBack = () => navigate(-1)
    backButton.show()
    backButton.onClick(handleBack)
    return () => {
      backButton.offClick(handleBack)
      backButton.hide()
    }
  }, [location.pathname, navigate])
}
